"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hauler_manager_1 = require("services/configuration/hauler-manager");
const driver_1 = require("services/master-data/driver");
const vessel_1 = require("services/master-data/vessel");
const contractor_1 = require("services/master-data/contractor");
const hauler_manager_types_1 = require("./hauler-manager.types");
const silo_1 = require("services/master-data/silo");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_manager_1._getHaulerManagerData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: `Error Fetching Data Configuration Hauler.
        ${response.errorMessage}. Error Code:${response.errorCode}
      `,
        };
        dispatch({ type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
                }),
        };
        dispatch({ type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        dataStates,
    };
    dispatch({ type: hauler_manager_types_1.haulerManagerTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => (dispatch) => {
    dispatch({ type: hauler_manager_types_1.haulerManagerTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = ({ mutationMode, dataItem }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        driver_id: dataItem.driver,
        hauler_id: dataItem.hauler_id,
        vessel_no_1: dataItem.vessel_no_1,
        vessel_no_2: dataItem.vessel_no_2,
        vessel_id_1: dataItem.vessel_id_1,
        vessel_id_2: dataItem.vessel_id_2,
        contractor_id: dataItem.contractor_id,
        checkpoint_id: dataItem.checkpoint_id,
    };
    if (mutationMode === 'edit')
        payload.id = dataItem.id;
    const response = mutationMode === 'add'
        ? yield (0, hauler_manager_1._postHaulerManagerData)(payload)
        : yield (0, hauler_manager_1._putHaulerManagerData)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.ON_SAVE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: true,
            },
        });
    }
});
const onDeleteDataItem = ({ dataItem }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_manager_1._deleteHaulerManagerData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode: 'delete',
                isSuccess: !response.isError,
            },
        });
    }
});
const onFilterChange = (payload) => (dispatch) => {
    dispatch({ type: hauler_manager_types_1.haulerManagerTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => (dispatch) => {
    dispatch({ type: hauler_manager_types_1.haulerManagerTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => (dispatch) => {
    dispatch({
        type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false,
        },
    });
};
const onLoading = () => (dispatch) => {
    dispatch({ type: hauler_manager_types_1.haulerManagerTypes.SET_LOADING, payload: true });
};
const onGetDataDriver = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, driver_1._getDriverByContractor)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Driver. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_DRIVER,
            payload: {
                id: payload.id,
                dataDriver: response.data,
            },
        });
    }
});
const onGetDataCheckpoint = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_1._getSiloData)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Silo. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_CHECKPOINT,
            payload: {
                dataSilo: response.isError
                    ? []
                    : response.data.map((item) => {
                        return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), checkpoint_name: item.silo, checkpoint_id: item.id });
                    }),
            },
        });
    }
});
const onGetDataHauler = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_manager_1._getHaulerContractorData)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Hauler. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_HAULER,
            payload: {
                id: payload.id,
                dataHauler: response.data,
            },
        });
    }
});
const onGetDataVessel1 = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, vessel_1._getMasterVesselByContractor)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Vessel 1. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_VESSEL_1,
            payload: {
                id: payload.id,
                vessel_no: payload.vessel_no,
                dataVessel1: response.data,
            },
        });
    }
});
const onGetDataVessel2 = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, vessel_1._getMasterVesselByContractor)(payload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Vessel 2. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_VESSEL_2,
            payload: {
                id: payload.id,
                vessel_no: payload.vessel_no,
                dataVessel2: response.data,
            },
        });
    }
});
const onGetDataContractor = ({ isExternal, contractor_name }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const newFilters = isExternal
        ? [
            { field: 'is_active', operator: 'eq', value: true },
            { field: 'coal_hauling', operator: 'eq', value: true },
            { field: 'contractor_name', operator: 'eq', value: contractor_name },
        ]
        : [
            { field: 'is_active', operator: 'eq', value: true },
            { field: 'coal_hauling', operator: 'eq', value: true },
        ];
    const contractorPayload = {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        total: 0,
        skip: 0,
        take: 100,
        sort: [{ field: 'contractor_name', dir: 'asc' }],
        filter: {
            logic: 'and',
            filters: newFilters,
        },
    };
    const response = yield (0, contractor_1.getMasterContractor)(contractorPayload);
    if (response.isError) {
        dispatch({
            type: hauler_manager_types_1.haulerManagerTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Contractor. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        const payload = response.data.filter((item) => item.contractor_name !== '');
        dispatch({ type: hauler_manager_types_1.haulerManagerTypes.SET_DATA_CONTRACTOR, payload });
    }
});
exports.default = {
    onLoading,
    getDataGrid,
    onSortChange,
    onCloseError,
    onFilterChange,
    onSaveDataItem,
    onClickMutation,
    onGetDataDriver,
    onGetDataHauler,
    onGetDataVessel1,
    onGetDataVessel2,
    onDeleteDataItem,
    onDataStateChange,
    onGetDataContractor,
    onGetDataCheckpoint,
};
